import NavBar from './NavBar';
import ToolBar from './ToolBar';
import ToolBarTrialBadge from './ToolBar/TrialBadge';
import NotFound from './NotFound';
import Error from './Error';
import Licensing from './Licensing';
import Common from './Common';
import Copyright from './Common/Copyright';
import SideBarLayout from './SideBarLayout';
import Loading from './Loading';
import Settings from './Settings';
import Panel from './Panel';
import FileEditor from './FileEditor';
export default {
  NavBar: NavBar,
  ToolBar: ToolBar,
  ToolBarTrialBadge: ToolBarTrialBadge,
  Common: Common,
  SideBarLayout: SideBarLayout,
  Loading: Loading,
  Settings: Settings,
  NotFound: NotFound,
  Licensing: Licensing,
  Error: Error,
  Panel: Panel,
  FileEditor: FileEditor,
  Copyright: Copyright
};